import * as React from 'react';

export function NotFoundPage() {
    return <h1>Page Not Found</h1>;
}
